/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-6e49aa22.mjs';
import { defineComponent, createVNode } from 'vue';
import props from './props.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { a as useContent } from '../_chunks/dep-5112e56c.mjs';
import '../_chunks/dep-6da93342.mjs';
import '../config-provider/hooks/useConfig.mjs';
import 'lodash-es';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';
import '../utils/render-tnode.mjs';

var _Divider = defineComponent({
  name: "TDivider",
  props: props,
  setup: function setup(props2) {
    var COMPONENT_NAME = usePrefixClass("divider");
    var renderContent = useContent();
    return function () {
      var layout = props2.layout,
        dashed = props2.dashed,
        align = props2.align;
      var children = renderContent("default", "content");
      var dividerClassNames = ["".concat(COMPONENT_NAME.value), ["".concat(COMPONENT_NAME.value, "--").concat(layout)], _defineProperty(_defineProperty(_defineProperty({}, "".concat(COMPONENT_NAME.value, "--dashed"), !!dashed), "".concat(COMPONENT_NAME.value, "--with-text"), !!children), "".concat(COMPONENT_NAME.value, "--with-text-").concat(align), !!children)];
      return createVNode("div", {
        "class": dividerClassNames
      }, [children && createVNode("span", {
        "class": "".concat(COMPONENT_NAME.value, "__inner-text")
      }, [children])]);
    };
  }
});

export { _Divider as default };
//# sourceMappingURL=divider.mjs.map
